import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Box, List, ListItem, ListItemIcon, Typography } from '@mui/material'
import { useMemo } from 'react'

import { useAppContext } from '@/hooks'

import type { ImportProgress } from '../../../types'

interface ImportSuccessContentProps {
	progress: ImportProgress
}

const MAX_DISPLAYED_STEPS = 10

export const ImportSuccessContent = ({ progress }: ImportSuccessContentProps) => {
	const { t } = useAppContext()

	const displayedSteps = useMemo(
		() => progress.completedSteps.slice(-MAX_DISPLAYED_STEPS),
		[progress.completedSteps],
	)

	return (
		<Box>
			<Box className="text-center mb-4">
				<CheckCircleIcon color="success" sx={{ fontSize: 64 }} className="mb-4" />
				<Typography variant="h6" className="mb-2">
					{t('IMPORT_SQL_SUCCESS')}
				</Typography>
				<Typography variant="body2" className="mb-4">
					{progress.message}
				</Typography>

				<Typography variant="caption" color="text.secondary">
					⚠️ Please review the changes before submitting them. Remember that AI can
					make mistakes.
				</Typography>
			</Box>

			{displayedSteps.length > 0 && (
				<Box>
					<Typography variant="body2" color="text.secondary" className="mb-2">
						{t('IMPORT_SQL_COMPLETED_STEPS')}:
					</Typography>
					<List dense>
						{displayedSteps.map((stepDesc, i) => (
							<ListItem key={i}>
								<ListItemIcon>
									<CheckCircleIcon color="success" fontSize="small" />
								</ListItemIcon>
								<Typography variant="body2">{stepDesc}</Typography>
							</ListItem>
						))}
					</List>
				</Box>
			)}
		</Box>
	)
}

